// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"7cb72dae","92":"390cd5ad","148":"a2882aa5","326":"71c2e943","367":"65fd60ee","394":"f5aa2c99","425":"dee8678f","453":"42a90b99","545":"4d67ec40","723":"b5447a9e","789":"b2e8866c","922":"d2914476"}[chunkId] + ".chunk.js";
};